import { Button } from '@toggle/design-system';
import styled from 'styled-components';

export const ExternalLink = styled(Button.Styled.ButtonRoot)`
  text-decoration: none;
  width: fit-content;
`;

export const Caption = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
